import React from "react"


import {FieldCSVImportPreviewProps} from "../../../../render/csv-import-preview";

export default function FieldTaskPredecessor_CSVImportPreview(props:FieldCSVImportPreviewProps) {

    // now default = viewSmall

    const value : any[] = props.field.getViewValue(props.model)

    return (
        <>
            {_.map(value, (importUID:string, key)=>{
                return <div className="ui5-property" key={key}>#{importUID}</div>
            })}
        </>
    )

}
